var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('y_choose_member',{on:{"change":_vm.choose}},[_c('el-button',[_vm._v(_vm._s(_vm.btnTxt))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }